import { FiLogOut, FiSettings } from "react-icons/fi";
import { NavLink } from "react-router-dom";

import { LanguageSelector } from "@/components/layout/LanguageSelector";
import { ThemeToggle } from "@/components/layout/ThemeToggle";
import { useTranslations } from "@/i18n";

export interface UserControlsProps {
  fullName?: string;
  onLogout: () => void;
  username?: string;
}

const iconClass =
  "group relative flex h-11 w-11 items-center justify-center rounded-lg text-muted transition-colors hover:bg-surface hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-ink";

const tooltipClass =
  "pointer-events-none absolute bottom-[calc(100%+0.35rem)] left-1/2 z-[70] -translate-x-1/2 whitespace-nowrap rounded-md bg-ink px-2 py-1 text-xs font-medium text-surface opacity-0 shadow-sm transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100";

export function UserControls({ fullName, onLogout, username }: UserControlsProps) {
  const t = useTranslations();
  const displayName = fullName?.trim() || username || t("common.Sidebar.reader");

  return (
    <div className="rounded-xl border border-line bg-canvas/50 p-2 shadow-sm">
      <p className="mb-1 truncate rounded-lg bg-accent/20 px-3 py-2 text-center text-base font-semibold tracking-tight text-ink">
        {displayName}
      </p>
      <div className="mt-1 flex items-center justify-center gap-1">
        <LanguageSelector iconOnly openUpward persistToAccount />
        <ThemeToggle openUpward />
        <NavLink
          aria-label={t("common.navigation.settings")}
          className={iconClass}
          to="/settings"
        >
          <FiSettings aria-hidden="true" className="h-5 w-5" />
          <span className={tooltipClass} role="tooltip">
            {t("common.navigation.settings")}
          </span>
        </NavLink>
        <button
          aria-label={t("common.Sidebar.logOut")}
          className={iconClass}
          onClick={onLogout}
          type="button"
        >
          <FiLogOut aria-hidden="true" className="h-5 w-5" />
          <span className={tooltipClass} role="tooltip">
            {t("common.Sidebar.logOut")}
          </span>
        </button>
      </div>
    </div>
  );
}
